import React from 'react'

import AccountButton from 'components/atoms/AccountButton'

const FormButton = props => (
  <AccountButton
    sx={{ margin: 1, textTransform: 'uppercase', fontStyle: 'normal' }}
    {...props}
  />
)

export default FormButton
